module.exports = __webpack_public_path__ + "static/media/geethu.a57f730c.jpg";